import { FinancePaymentViewModel, FindFinancePaymentsQuery } from 'chaika-frontend-types/frontend-cms';

import { LongList } from '@store/abstract/LongList';

export class PaymentsList extends LongList<FinancePaymentViewModel, FinancePaymentViewModel, FindFinancePaymentsQuery> {
    public readonly limit: number = 50;

    protected create(params: FinancePaymentViewModel): FinancePaymentViewModel {
        return params;
    }
}
